var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-app-layout-type-a"},[_c('WsNavDrawer',{attrs:{"items":_vm.drawerItems,"dropdownItems":_vm.drawerDropdownItems,"dropdownValue":_vm.drawerDropdownValue},on:{"dropdown-input":function($event){return _vm.$emit('drawer-dropdown-input',$event)}}}),_c('router-view',{staticClass:"view-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }